import React, { useState, useEffect } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

import VariationsTable from "./components/TenantList";

import { ListTenant } from "./data/data";
import VariationTable from "./components/TenantList";
import {
  AppLayout,
  Box,
  BreadcrumbGroup,   
  ContentLayout,
  Header,
  Icon,
  Link,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";
import { Navigation } from "../../../components/app/Navigation";
// import '@cloudscape-design/global-styles/index.css'
import { listTenants } from "../../../graphql/queries";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import { ListTenantsQueryVariables } from "../../../API";

const client = generateClient()
Amplify.configure(config);

export default function SystemListTenant() {
  const [activeHref, setActiveHref] = React.useState("/system/tenants");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [listTenant, setListTenant] = useState<ListTenant[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(()=>{
    fetchTenants();
  }, []);

  async function fetchTenants(limit= 100) {
    try {
      let nextToken : string | null = null;
      let allTenants: ListTenant[]=[];

      do{

      const variables: ListTenantsQueryVariables = {limit, nextToken};   
        let response = await client.graphql({
        query: listTenants,
        authMode : 'userPool',
        variables,
      });
      const tenants = response.data.listTenants.items;
      nextToken = response.data.listTenants.nextToken ?? null;


      const newTenants: ListTenant[] = tenants.map((tenant:any)  => {
          const formattedTimestamp = new Date(tenant.updatedAt).toLocaleString();
          return{
          id: tenant["id"],
          TenantName: tenant["tenantname"] ?? "",
          Subtenant: tenant["subtenant"] ?? "",
          Address: tenant["address"] ?? "",
          Contact: tenant["contact"]  ?? "",
          Phone: tenant["phone"] ?? "",
          Status: tenant["status"] ?? "",
          ServicePacakge: tenant["servicepackage"] ?? "",
          StatusPayment: Boolean(tenant["statuspayment"]),
          Timestamps: formattedTimestamp??"",
        };
      });
      allTenants=[...allTenants, ...newTenants];
    } while (nextToken);

      
      setListTenant(allTenants);
      setIsLoading(false);
     //updateTotal_tenant(allTenants.length)

    } catch (err) {
      console.log("error fetching tenants : ", err);
    }
  }

  
  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "System",
                href: "/system",
              },
              {
                text: "Tenant Detail",
                href: "/system/tenants",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
            // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/system/tenants" ? `Tenant Detail ` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{marginTop: isLoading ? '160px' : '0px'}}>
            {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading tenant data...</Box>
                </Box>
              ) : (
                <VariationsTable ListTenant={listTenant} refreshData={fetchTenants}/>
              )}
              
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}
